import { Component, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ChatFilterType } from './sidebar.const';
import { AssignList } from '../../search/search.const';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'chat-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
@Injectable()
export class ChatSideBar {
  nav = '';
  channels = [
    {
      url: `/chatting/${ChatFilterType.All}`,
      name: 'Tất cả hội thoại',
    },
    {
      url: `/chatting/${ChatFilterType.Live}`,
      name: 'Livechat',
    },
    {
      url: `/chatting/${ChatFilterType.Zalo}`,
      name: 'Zalo',
    },
    {
      url: `/chatting/${ChatFilterType.Facebook}`,
      name: 'Facebook',
    },
  ];

  protected readonly assignList = AssignList;

  constructor(private router: Router) {
    this.nav = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.nav = event.url;
      }
    });
  }

  onNav(url) {
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/side-bar/sidebar.component.ts